<template>
  <div id="app">
    <Navbar />
    <NavbarMb />
    <router-view />
    <Footer />
  </div>
</template>

<script>
import Navbar from "@/components/Navbar";
import NavbarMb from "@/components/NavbarMb";
import Footer from "@/components/Footer";
export default {
  components: { Navbar, Footer, NavbarMb },
};
</script>

<style lang="scss">
@font-face {
  font-family: "Aspira";
  src: url("./assets/fonts/Aspira_Medium.otf");
  font-weight: normal;
}

@font-face {
  font-family: "Aspira";
  src: url("./assets/fonts/Aspira_Bold.otf");
  font-weight: bold;
}

@font-face {
  font-family: "Aspira";
  src: url("./assets/fonts/Aspira_Light.otf");
  font-weight: 100;
}

body {
  font-family: "Aspira";
  
  .slick-dots {
    bottom: 10px;
  }

  .slick-dots li button::before {
    color: white;
    font-size: 12px;
  }
}

</style>
